import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import StarGroup from './StarGroup';
import { scaleW } from '@/common/style';
import { IComment } from './types';
import { vIf } from '@/common/utils/vIf';
import Image from '@kds/image';

const style = StyleSheet.create({"container":{},"info":{"flexDirection":"row","justifyContent":"space-between","alignItems":"center"},"avatar":{"width":"6.76328502415459rem","height":"6.76328502415459rem","borderRadius":"3.381642512077295rem"},"username":{"marginHorizontal":"1.9323671497584543rem","color":"rgba(0, 0, 0, 0.88)","maxWidth":"31.40096618357488rem"},"commentWrapper":{"flexDirection":"row","alignItems":"flex-end"},"comment":{"color":"rgba(0, 0, 0, 0.88)","fontSize":"3.8647342995169085rem","flexShrink":1,"lineHeight":"4.5893719806763285rem"},"image":{"width":"9.66183574879227rem","height":"9.66183574879227rem","borderRadius":"1.9323671497584543rem","marginLeft":"3.381642512077295rem"}});

const CommentCardMiniSimple = (props: IComment) => {
    return (
        <View style={style.container}>
            <View style={style.info}>
                <View
                    style={{"flexDirection":"row","alignItems":"center"}}>
                    <Image style={style.avatar} source={{ uri: props.userHeadUrl }} />
                    <Text numberOfLines={1} ellipsizeMode={'tail'} style={style.username}>
                        {props.userName}
                    </Text>
                </View>
                <View
                    style={{"marginRight":"-0.9661835748792271rem"}}>
                    <StarGroup yellowStarCount={props.productScore} />
                </View>
            </View>
            <View
                style={{"flexDirection":"row","justifyContent":"flex-start","alignItems":"flex-start","marginTop":"1.9323671497584543rem"}}>
                <View style={{"flex":1}}>
                    {vIf(
                        Boolean(props.detail),
                        <View style={style.commentWrapper}>
                            <Text numberOfLines={2} style={style.comment}>
                                {props.detail}
                            </Text>
                        </View>
                    )}
                </View>

                {vIf(props.imageUrl?.length > 0, <Image style={style.image} source={{ uri: props.imageUrl[0] }} resizeMethod="resize" />)}
            </View>
        </View>
    );
};

export default CommentCardMiniSimple;
